/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import {
	RichText 
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'
import { 
	ButtonEditHelper, ImageUploadPlaceholder 
} from '~cartzillagb/components'

/**
 * External dependencies
 */
import classnames from 'classnames'

const save = props => {
		const { 
		attributes, 
		className
	} = props 

	const {
		banner1Pretitle,
		banner1Title,
		banner2Title,
		banner2Desc,
		hideLeftbanner,
		hideRightbanner,
		mediaURL,
		backgroundColor,
		backgroundImageURL,
		background,
		bgcolor,
		enableImage,
		custombgcolor,
		enableButton1,
		enableButton2,
		enableContainer,
		containerClass
	} = attributes

	const mainClasses = classnames( [
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const styleAttr = {}

	if ( backgroundImageURL || backgroundColor ) {
		styleAttr.style = {
			backgroundImage: `url( ${ backgroundImageURL } )`,
			backgroundColor: backgroundColor && backgroundColor, 
		}
	}

	const bgstyle = { backgroundColor: custombgcolor && custombgcolor }

	return (
		<div className={ mainClasses }>
			<section className={ `banner ${ enableContainer === true ? 'container ': '' }${ containerClass }` }>
				<div className="row">
					{ hideLeftbanner &&
					<div className={ `col-md-${ hideRightbanner === false ? '12' : '8' } mb-4` } >
						<div className={ `d-sm-flex justify-content-between align-items-center overflow-hidden rounded-lg ${ bgcolor ? bgcolor : custombgcolor ? '' : 'bg-secondary' }` } style={ bgstyle } >
							<div className="py-4 my-2 my-md-0 py-md-5 px-4 ml-md-3 text-center text-sm-left">
								<RichText.Content
									tagName="h4"
									className="font-size-lg font-weight-light mb-2" 
									value={ banner1Pretitle || 'Hurry up! Limited time offer' }
								/>
								<RichText.Content
									tagName="h3"
									className="mb-4" 
									value={ banner1Title || 'Converse All Star on Sale' }
								/>
								{ enableButton1 &&
									<ButtonEditHelper.Content
										attrNameTemplate={ `button1%s` }
										blockAttributes={ props.attributes }
									/>
								}
							</div>
							{ enableImage &&
								<ImageUploadPlaceholder
									className={ `d-block ml-auto` }
									imageURL={ mediaURL }
									render={ <img src={ mediaURL } alt={ __( 'Shop Converse' ) } /> }
								/>
							}
						</div>
					</div>
					}

					{ hideRightbanner &&
						<div className={ `col-md-${ hideLeftbanner === false ? '12' : '4' } mb-4` }>
							<div className={ `d-flex flex-column h-100 justify-content-center bg-size-cover bg-position-center rounded-lg ${ background }` } { ...styleAttr }>
								<div className="py-4 my-2 px-4 text-center">
									<div className="py-1">
										<RichText.Content
											tagName="h5"
											className="mb-2" 
											value={ banner2Title || 'Last Gen iPad Pro' }
										/>
										<RichText.Content
											tagName="p"
											className="font-size-sm text-muted" 
											value={ banner2Desc || 'Last Gen iPad Pro' }
										/>
										{ enableButton2 &&
											<ButtonEditHelper.Content
												attrNameTemplate={ `button2%s` }
												blockAttributes={ props.attributes }
											/>
										}
									</div>
								</div>
							</div>
						</div>
					}
				</div>
			</section>
		</div>
	)
}

export default compose(
)( save )